module.exports = __webpack_public_path__ + "media/images/coupon/nonactivated-66ade9471431c1947e8d6d17632cb958.png";